/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
import '../../polyfill-support.js';
import '../reactive-element_test.js';
import '../reactive-element_styling_test.js';
import '../css-tag_test.js';
